<!-- eslint-disable max-len -->
<route>
{
  "meta": {
    "requireAdmin": true,
    "customSite": true
  }
}
</route>
<template>
  <div class="pb-3 px-3">
    <div class="text-right pb-4">
      <VueMultiselectComponent
        class="ml-4 mt-1"
        v-model="selected"
        :options="options"
      />
      <input
        ref="main"
        type="text"
        placeholder="Student Name"
        class="input input-bordered w-48"
        name="student name"
        v-model="studentName"
      />
      <input
        type="text"
        placeholder="Course Name"
        class="input input-bordered w-48 ml-4 mt-1"
        name="course name"
        v-model="courseName"
      />
      <button
        :disabled="courseName.trim() === '' && selected.length === 0 && studentName.trim() === ''"
        type="button"
        class="p-2 px-3 rounded-md ml-4 btn mt-1 btn-primary"
        @click="addfilter"
      >
        Search
      </button>
      <button
        :disabled="!isclear"
        type="button"
        class="p-2 px-3 ml-4 rounded-md btn mt-1 btn-primary"
        @click="getavtivities(); courseName = ''; studentName = ''; pagenumber = 1; start = -1;"
      >
        Clear
      </button>
      </div>
    <h3 v-if="!Activitylogs.length" class="my-24 text-center font-medium text-xl">There are no user activities yet.</h3>
    <div class="pl-3 mb-0" v-for="index in pagecount" :key="index">
      <div v-if="Activitylogs[index + start]" class="grid items-center mt-0">
        <div class="grid grid-cols-2 mt-3" v-if="showcourse(Activitylogs[index + start].courseName, index + start)">
          <h3 class="font-medium text-xl inline-block">Course: {{ Activitylogs[index + start].courseName }}</h3>
            <div class="text-right mr-2">
                  <div class="tooltip" data-tip="Course Filter">
                    <font-awesome-icon
                      class="reaction text-gray-600"
                      size="lg"
                      :icon="['fas', 'filter']"
                      @click="courseName = Activitylogs[index + start].courseName; addfilter()"
                    />
                  </div>
            </div>
        </div>
        <div
          class="grid items-center ml-6"
        >
          <div :class="
          showcourse(Activitylogs[index + start].courseName, index + start)
          ? 'mt-0 mb-1'
          : 'mt-4 mb-1'
          "
          v-if="showlesson(Activitylogs[index + start].lessonName, index + start)">
            <h3 class="font-medium text-base inline-block mb-0">Lesson: {{ Activitylogs[index + start].lessonName }}</h3>
          </div>
          <div class="grid items-center ml-10">
            <div class="grid bg-white grid-cols-2 p-2 mt-3" v-if="showname(Activitylogs[index + start].studentName, index + start)">
              <h3 class="font-medium text-base mt-2 inline-block mb-1">{{ Activitylogs[index + start].studentName }}</h3>
              <div class="text-right mr-2">
                  <div class="tooltip" data-tip="Student Filter">
                    <font-awesome-icon
                      class="reaction text-gray-600"
                      size="lg"
                      :icon="['fas', 'filter']"
                      @click="studentName = Activitylogs[index + start].studentName; addfilter()"
                    />
                  </div>
                  <button
                    v-if="Activitylogs[index + start].courseType === 'twitter'"
                    type="button"
                    class="p-2 px-3 ml-4 rounded-md btn-primary"
                    @click="DMpopup = true; DMstudent = Activitylogs[index + start].studentProviderId"
                  >
                    DM
                  </button>
              </div>
            </div>
            <div
              class="grid bg-white items-center"
            >
              <div class="grid ml-12 grid-cols-2 p-2">
                <h3 class="font-medium text-base inline-block p-3 mb-0">{{ Activitylogs[index + start].lessonStep.toLowerCase() }} {{ showDateTime(Activitylogs[index + start].createdAt) }}
                  <h3 class="font-medium text-base mr-1 inline-block mb-0"
                  v-if="Activitylogs[index + start].lessonStep === 'BACKGROUND COMPLETED' ||
                        Activitylogs[index + start].lessonStep === 'CHECK COMPLETED' ||
                        Activitylogs[index + start].lessonStep === 'ASSIGNMENT SUBMITTED' ||
                        Activitylogs[index + start].lessonStep === 'FEEDBACK SUBMITTED' ||
                        Activitylogs[index + start].lessonStep === 'PARTICIPATION SUBMITTED'"
                  > :
                  </h3>
                  <h3 class="font-medium text-base inline-block mb-0"
                  v-if="Activitylogs[index + start].lessonStep === 'BACKGROUND COMPLETED'"
                > {{ Activitylogs[index + start].lessonDetails.background.toString()}}</h3>
                <h3 class="font-medium text-base inline-block mb-0"
                  v-if="Activitylogs[index + start].lessonStep === 'CHECK COMPLETED'"
                > {{ Activitylogs[index + start].lessonDetails.check.toString()}}</h3>
                <h3 class="font-medium text-base inline-block mb-0"
                  v-if="Activitylogs[index + start].lessonStep === 'ASSIGNMENT SUBMITTED'"
                > {{ Activitylogs[index + start].courseType === 'twitter' ? Activitylogs[index + start].lessonDetails.referenceData.text : Activitylogs[index + start].lessonDetails.referenceData.mailText }}</h3>
                <h3 class="font-medium text-base inline-block mb-0"
                  v-else-if="Activitylogs[index + start].lessonStep === 'FEEDBACK SUBMITTED'"
                >{{Activitylogs[index + start].lessonDetails.referenceData.feedBackData.tweetText}}</h3>
                <h3 class="font-medium text-base inline-block mb-0"
                  v-else-if="Activitylogs[index + start].lessonStep === 'PARTICIPATION SUBMITTED'"
                >{{Activitylogs[index + start].lessonDetails.referenceData.participantData.tweetText}}</h3>
                </h3>
                <div v-if="Activitylogs[index + start].courseType === 'twitter'" class="text-right mr-2">
                  <button
                    type="button"
                    class="btn btn-primary"
                    v-if="Activitylogs[index + start].lessonStep === 'ASSIGNMENT SUBMITTED'"
                    @click="
                      showAssignmentTweet(Activitylogs[index + start].lessonDetails.referenceData)
                    "
                  >
                    {{ Activitylogs[index + start].lessonDetails.referenceData.submittedvia === 'DM' ?  'Go To DM' : 'Go To Tweet' }}
                  </button>
                  <button
                    type="button"
                    class="btn btn-primary"
                    v-else-if="Activitylogs[index + start].lessonStep === 'FEEDBACK SUBMITTED'"
                    @click="
                      showFeedbackTweet(Activitylogs[index + start].lessonDetails.referenceData)
                    "
                  >
                    Go To Tweet
                  </button>
                  <button
                    type="button"
                    class="btn btn-primary"
                    v-else-if="
                      Activitylogs[index + start].lessonStep === 'PARTICIPATION SUBMITTED'
                    "
                    @click="
                      showParticipantTweet(Activitylogs[index + start].lessonDetails.referenceData)
                    "
                  >
                    Go To Tweet
                  </button>
                  <button
                    type="button"
                    class="btn ml-4 btn-primary mt-1"
                    v-if="Activitylogs[index + start].lessonStep === 'ASSIGNMENT SUBMITTED' &&  Activitylogs[index + start].lessonDetails.referenceData.submittedvia !== 'DM'"
                    @click="setAssignmentDetails(Activitylogs[index + start])"
                  >
                    Reply
                  </button>
                  <button
                    type="button"
                    class="btn ml-4 btn-primary mt-1"
                    v-else-if="Activitylogs[index + start].lessonStep === 'FEEDBACK SUBMITTED'"
                    @click="setFeedBackDetails(Activitylogs[index + start])"
                  >
                    Reply
                  </button>
                  <button
                    type="button"
                    class="btn ml-4 btn-primary mt-1"
                    v-else-if="
                      Activitylogs[index + start].lessonStep === 'PARTICIPATION SUBMITTED'
                    "
                    @click="setParticipantDetails(Activitylogs[index + start])"
                  >
                    Reply
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="pl-3 btn-group">
      <button :disabled="start === -1" class="btn" @click="prev">«</button>
      <button class="btn">Page {{ pagenumber }}</button>
      <button :disabled="!Activitylogs[start + pagecount]" class="btn" @click="next" >»</button>
    </div>
    <transition
      enter-active-class="transition duration-300 ease-out transform"
      enter-class="scale-95 opacity-0"
      enter-to-class="scale-100 opacity-100"
      leave-active-class="transition duration-150 ease-in transform"
      leave-class="scale-100 opacity-100"
      leave-to-class="scale-95 opacity-0"
    >
      <div
        v-if="DMpopup"
        class="flex items-center justify-center fixed left-0 bottom-0 w-full h-full"
        style="background-color: #00000099"
      >
        <div class="bg-white rounded-lg  w-144">
          <div class="flex flex-col items-start p-4">
            <div class="flex items-center w-full">
              <div class="text-gray-900 font-bold text-lg">Send DM</div>
              <svg
                class="ml-auto fill-current text-gray-700 w-6 h-6 cursor-pointer"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 18 18"
                @click="DMpopup = false; message = ''"
              >
                <path
                  d="M14.53 4.53l-1.06-1.06L9 7.94 4.53 3.47 3.47 4.53 7.94 9l-4.47 4.47 1.06 1.06L9 10.06l4.47 4.47 1.06-1.06L10.06 9z"
                />
              </svg>
            </div>
            <hr class="w-full my-3" />
            <textarea
              class="textarea h-40 textarea-bordered w-full mb-1"
              placeholder="Message"
              required
              name="message"
              v-model="message"
            />
            <hr class="w-full my-3" />
            <div class="ml-auto">
              <button :disabled="message.trim() === ''" class="btn btn-primary" @click="sendDM">Send</button>
              <button class="btn btn-outline ml-3" @click="DMpopup = false; message = ''">Cancel</button>
            </div>
          </div>
        </div>
      </div>
    </transition>
    <transition
      enter-active-class="transition duration-300 ease-out transform"
      enter-class="scale-95 opacity-0"
      enter-to-class="scale-100 opacity-100"
      leave-active-class="transition duration-150 ease-in transform"
      leave-class="scale-100 opacity-100"
      leave-to-class="scale-95 opacity-0"
    >
      <div
        v-if="feedPopup"
        class="
          flex
          items-center
          justify-center
          fixed
          left-0
          bottom-0
          w-full
          h-full
        "
        style="background-color: #00000099"
      >
        <div class="bg-white rounded-lg w-1/4">
          <div class="flex flex-col items-start p-4">
            <div class="flex items-center w-full">
              <div class="text-gray-900 font-bold text-lg">
                Reply To Student Tweet
              </div>
              <svg
                class="
                  ml-auto
                  fill-current
                  text-gray-700
                  w-6
                  h-6
                  cursor-pointer
                "
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 18 18"
                @click="closePopup"
              >
                <path
                  d="M14.53 4.53l-1.06-1.06L9 7.94 4.53 3.47 3.47 4.53 7.94 9l-4.47 4.47 1.06 1.06L9 10.06l4.47 4.47 1.06-1.06L10.06 9z"
                />
              </svg>
            </div>
            <hr class="w-full my-3" />
            <textarea
              class="textarea h-40 textarea-bordered w-full mb-1"
              placeholder="Message"
              required
              name="message"
              v-model="message"
            />
            <hr class="w-full my-3" />
            <div class="ml-auto">
              <button :disabled="message.trim() === ''" class="btn btn-primary" @click="SendConfirmed">
                Send
              </button>
              <button class="btn btn-outline ml-3" @click="closePopup">
                Cancel
              </button>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import VueMultiselectComponent from 'vue-multiselect-component';
import showdown from 'showdown';
import moment from 'moment';
import store from '@/store';
import userInfo from '@/services/userInfo';
import utils from '@/services/utils';
import lesson from '@/services/lesson';
import admin from '@/services/admin';

export default {
  name: 'user-activity',
  layout: 'admin',
  store,
  components: {
    VueMultiselectComponent,
  },
  data() {
    return {
      Activitylogs: [],
      feedPopup: false,
      studentId: '',
      selected: ['LESSON STARTED', 'BACKGROUND COMPLETED', 'LEARN COMPLETED', 'CHECK COMPLETED', 'ASSIGNMENT SUBMITTED', 'FEEDBACK SUBMITTED', 'PARTICIPATION SUBMITTED', 'LESSON COMPLETED'],
      options: [
        { id: 'LESSON STARTED', label: 'lesson started' },
        { id: 'BACKGROUND COMPLETED', label: 'background completed' },
        { id: 'LEARN COMPLETED', label: 'learn completed' },
        { id: 'CHECK COMPLETED', label: 'check completed' },
        { id: 'ASSIGNMENT SUBMITTED', label: 'assignment submitted' },
        { id: 'FEEDBACK SUBMITTED', label: 'feedback submitted' },
        { id: 'PARTICIPATION SUBMITTED', label: 'participation submitted' },
        { id: 'LESSON COMPLETED', label: 'lesson completed' },
      ],
      tweetId: '',
      message: '',
      DMpopup: false,
      DMstudent: '',
      sort: '',
      start: -1,
      pagenumber: 1,
      courseName: '',
      studentName: '',
      isclear: false,
      pagecount: 20,
      addPoll: false,
      firstOption: '',
      secondOption: '',
      thirdOption: '',
      selectFirst: '',
      selectSecond: '',
      selectThird: '',
      segmentOnly: [],
      allCourseList: [],
      userId: '',
      userData: null,
    };
  },
  computed: {
    user() {
      return store.state.user;
    },
  },
  async mounted() {
    store.commit('toggleLoading', true);
    await this.getavtivities();
  },
  methods: {
    getavtivities() {
      userInfo
        .getuseractivities(this.user.uid)
        .then((data) => {
          store.commit('toggleLoading', false);
          this.Activitylogs = data.courseLessonActivityLogs;
          this.isclear = false;
        })
        .catch((error) => {
          store.commit('toggleLoading', false);
          console.log({ error });
        });
    },
    addfilter() {
      this.studentName = this.studentName.trim();
      this.courseName = this.courseName.trim();
      store.commit('toggleLoading', true);
      console.log(this.studentName, this.courseName);
      const payload = {
        studentName: this.studentName,
        courseName: this.courseName,
        courseCreatorId: this.user.uid,
        sort: this.selected,
      };
      userInfo
        .getfiltredactivity(payload)
        .then((data) => {
          this.Activitylogs = data.data;
          console.log(this.Activitylogs);
          this.isclear = true;
          this.pagenumber = 1;
          this.start = -1;
          store.commit('toggleLoading', false);
        })
        .catch((error) => {
          store.commit('toggleLoading', false);
          console.log({ error });
        });
    },
    next() {
      this.pagenumber += 1;
      this.start += this.pagecount;
      this.$refs.main.focus();
    },
    prev() {
      this.pagenumber -= 1;
      this.start -= this.pagecount;
      this.$refs.main.focus();
    },
    markdownToHTML(markdown) {
      const converter = new showdown.Converter();
      return converter.makeHtml(markdown);
    },
    closePopup() {
      this.feedPopup = false;
      this.message = '';
    },
    showAssignmentTweet(referenceData) {
      const tweetUrl = referenceData.submittedvia === 'DM' ? `https://twitter.com/messages/compose?recipient_id=${referenceData.user.providerId}` : `https://twitter.com/${referenceData.user.screen_name}/status/${referenceData.id_str}`;
      window.open(tweetUrl, '_blank');
    },
    showFeedbackTweet(referenceData) {
      const tweetUrl = `https://twitter.com/${referenceData.user.acctUsername}/status/${referenceData.feedBackData.tweetId}`;
      window.open(tweetUrl, '_blank');
    },
    showParticipantTweet(referenceData) {
      const tweetUrl = `https://twitter.com/${referenceData.user.acctUsername}/status/${referenceData.participantData.tweetId}`;
      window.open(tweetUrl, '_blank');
    },
    async sendDM() {
      store.commit('toggleLoading', true);
      if (this.message === '') {
        store.commit('toggleLoading', false);
        utils.setStatusMsg(this, 'Message cannot be empty');
        return;
      }
      console.log(this.message);
      console.log(this.DMstudent);
      const list = [];
      list.push(this.DMstudent);
      const data = {
        providerIds: list,
        message: this.message,
      };
      await admin
        .sendDM(data)
        .then((data1) => {
          store.commit('toggleLoading', false);
          console.log(data1);
          this.DMpopup = false;
        })
        .catch((error) => {
          store.commit('toggleLoading', false);
          if (error.response.status === 401) {
            utils.setStatusMsg(this, 'Failed to send DM');
            this.$router.push({ path: '/' });
          }
          console.log(error);
        });
      this.message = '';
    },
    async SendConfirmed() {
      store.commit('toggleLoading', true);
      if (this.message === '') {
        store.commit('toggleLoading', false);
        utils.setStatusMsg(this, 'Message cannot be empty');
        return;
      }
      const data = {
        studentId: this.studentId,
        tweetId: this.tweetId,
        message: this.message.trim(),
      };
      await lesson
        .ReplyTweet(data)
        .then((data1) => {
          console.log(data1);
          utils.setStatusMsg(this, data1.message);
          this.message = '';
          this.feedPopup = false;
          store.commit('toggleLoading', false);
        })
        .catch((err) => {
          utils.setStatusMsg(this, err.response.data.message);
          console.log(err);
          this.message = '';
          this.feedPopup = false;
          store.commit('toggleLoading', false);
        });
    },
    setAssignmentDetails(Activity) {
      this.feedPopup = true;
      this.studentId = Activity.studentId;
      this.tweetId = Activity.lessonDetails.referenceData.id_str;
      this.tweetText = Activity.lessonDetails.referenceData.text;
    },
    setFeedBackDetails(Activity) {
      console.log(Activity);
      this.feedPopup = true;
      this.studentId = Activity.studentId;
      this.tweetId = Activity.lessonDetails.referenceData.feedBackData.tweetId;
    },
    setParticipantDetails(Activity) {
      console.log(Activity);
      this.feedPopup = true;
      this.studentId = Activity.studentId;
      this.tweetId =
        Activity.lessonDetails.referenceData.participantData.tweetId;
    },
    showDateTime(DateTime) {
      return moment(DateTime).fromNow();
    },
    showcourse(first, second) {
      return this.start === second - 1 ? true : !this.Activitylogs[second - 1] || first !== this.Activitylogs[second - 1].courseName;
    },
    showlesson(first, second) {
      let show = false;
      if (first) {
        show = this.start === second - 1 ? true : !this.Activitylogs[second - 1] || first !== this.Activitylogs[second - 1].lessonName;
      }
      return show;
    },
    showname(first, second) {
      return this.start === second - 1 ? true : !this.Activitylogs[second - 1] || first !== this.Activitylogs[second - 1].studentName || (this.Activitylogs[second].lessonName && this.Activitylogs[second - 1].lessonName !== this.Activitylogs[second].lessonName);
    },
  },
};
</script>
